import type { QueryParams } from "../../types";

// Query keys for React Query
export const projectsKeys = {
  all: ["projects"] as const,
  list: (params: QueryParams) => [...projectsKeys.all, "list", params] as const,
  detail: (id: number | string | undefined) => [...projectsKeys.all, "detail", id] as const,
  projectData: () => [...projectsKeys.all, "projectData"] as const,
  adahiData: () => [...projectsKeys.all, "adahiData"] as const,
};
